import { NestedHome } from '@habity/types';

export const hasVirtualTour = (home: NestedHome) => {
  const { provider_data } = home || {};
  const { advertiseOn } = provider_data || {};
  const { links } = advertiseOn || {};
  const virtualTour = links?.find(
    (link: TODO) => link.text === 'Virtuell visning'
  );
  return !!virtualTour;
};

export const getVirtualTourUrl = (home: NestedHome) => {
  const { provider_data } = home || {};
  const { advertiseOn } = provider_data || {};
  const { links } = advertiseOn || {};
  const virtualTour = links?.find(
    (link) => link.text === 'Virtuell visning'
  );
  const { links: virtualTourLinks } = virtualTour || {};
  const tourUrl =
    virtualTourLinks && virtualTourLinks.length > 0 ? virtualTourLinks[0] : '';
  return tourUrl;
};
